<template>
    <button @click.self="doCallback">
      {{title}}
      <span v-show="icon" class="nextBtn" :class="icon"></span>
    </button>
</template>

  <script>
    export default {
      mame:'optionButton',
      props:['title','callback',"icon","routeObj"],
      data(){
          return {
          }
      },
      methods: {
        // 执行传来的回调函数
        doCallback(){
        if(typeof this.routeObj != 'undefined'){
          return this.callback(this.routeObj)
        }
          if(this.callback){
            this.callback()
          }
        },
      },
    }
</script>
  <style lang="less" scoped>
      button{
        position: relative;
        background-color: @colorMain;
        color: #fff;
        border: none;
        width: 225px;
        height: 56px;
        font-family: Source Han Sans TW;
        border-radius: 10px;
        margin: 0 auto;
        font-size: 18px;
        .nextBtn{
          position: absolute;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          color: #000;
          background-color: #fff;
          text-align: left;
          line-height: 25px;
          font-size: 20px;
          right: 10px;
          color:@colorMain;
        }
        .nextBtn:hover{
          opacity: 0.8;
        }
      }
      button:hover{
          color: #fff;
          background-color:@colorMain ;
          cursor: pointer;
          opacity: .8;
      }
      button:leave{
          color: #fff;
          background-color:@colorMain ;
      }
      @media screen and (max-width: 765px){
      button{
          width: 180px;
          height: 45px;
          border-radius: 6px;
      }
    }

  </style>
